/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "eile",
        "-2": "üleeile",
        "0": "täna",
        "1": "homme",
        "2": "ülehomme",
        "future": {
          "one": "{0} päeva pärast",
          "other": "{0} päeva pärast"
        },
        "past": {
          "one": "{0} päeva eest",
          "other": "{0} päeva eest"
        }
      },
      "day-narrow": {
        "-1": "eile",
        "-2": "üleeile",
        "0": "täna",
        "1": "homme",
        "2": "ülehomme",
        "future": {
          "one": "{0} p pärast",
          "other": "{0} p pärast"
        },
        "past": {
          "one": "{0} p eest",
          "other": "{0} p eest"
        }
      },
      "day-short": {
        "-1": "eile",
        "-2": "üleeile",
        "0": "täna",
        "1": "homme",
        "2": "ülehomme",
        "future": {
          "one": "{0} p pärast",
          "other": "{0} p pärast"
        },
        "past": {
          "one": "{0} p eest",
          "other": "{0} p eest"
        }
      },
      "hour": {
        "0": "praegusel tunnil",
        "future": {
          "one": "{0} tunni pärast",
          "other": "{0} tunni pärast"
        },
        "past": {
          "one": "{0} tunni eest",
          "other": "{0} tunni eest"
        }
      },
      "hour-narrow": {
        "0": "praegusel tunnil",
        "future": {
          "one": "{0} t pärast",
          "other": "{0} t pärast"
        },
        "past": {
          "one": "{0} t eest",
          "other": "{0} t eest"
        }
      },
      "hour-short": {
        "0": "praegusel tunnil",
        "future": {
          "one": "{0} t pärast",
          "other": "{0} t pärast"
        },
        "past": {
          "one": "{0} t eest",
          "other": "{0} t eest"
        }
      },
      "minute": {
        "0": "praegusel minutil",
        "future": {
          "one": "{0} minuti pärast",
          "other": "{0} minuti pärast"
        },
        "past": {
          "one": "{0} minuti eest",
          "other": "{0} minuti eest"
        }
      },
      "minute-narrow": {
        "0": "praegusel minutil",
        "future": {
          "one": "{0} min pärast",
          "other": "{0} min pärast"
        },
        "past": {
          "one": "{0} min eest",
          "other": "{0} min eest"
        }
      },
      "minute-short": {
        "0": "praegusel minutil",
        "future": {
          "one": "{0} min pärast",
          "other": "{0} min pärast"
        },
        "past": {
          "one": "{0} min eest",
          "other": "{0} min eest"
        }
      },
      "month": {
        "-1": "eelmine kuu",
        "0": "käesolev kuu",
        "1": "järgmine kuu",
        "future": {
          "one": "{0} kuu pärast",
          "other": "{0} kuu pärast"
        },
        "past": {
          "one": "{0} kuu eest",
          "other": "{0} kuu eest"
        }
      },
      "month-narrow": {
        "-1": "eelm. k",
        "0": "see k",
        "1": "järgm. k",
        "future": {
          "one": "{0} k pärast",
          "other": "{0} k pärast"
        },
        "past": {
          "one": "{0} k eest",
          "other": "{0} k eest"
        }
      },
      "month-short": {
        "-1": "eelm. kuu",
        "0": "see kuu",
        "1": "järgm. kuu",
        "future": {
          "one": "{0} kuu pärast",
          "other": "{0} kuu pärast"
        },
        "past": {
          "one": "{0} kuu eest",
          "other": "{0} kuu eest"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "eelmine kvartal",
        "0": "käesolev kvartal",
        "1": "järgmine kvartal",
        "future": {
          "one": "{0} kvartali pärast",
          "other": "{0} kvartali pärast"
        },
        "past": {
          "one": "{0} kvartali eest",
          "other": "{0} kvartali eest"
        }
      },
      "quarter-narrow": {
        "-1": "eelmine kv",
        "0": "käesolev kv",
        "1": "järgmine kv",
        "future": {
          "one": "{0} kv pärast",
          "other": "{0} kv pärast"
        },
        "past": {
          "one": "{0} kv eest",
          "other": "{0} kv eest"
        }
      },
      "quarter-short": {
        "-1": "eelmine kv",
        "0": "käesolev kv",
        "1": "järgmine kv",
        "future": {
          "one": "{0} kv pärast",
          "other": "{0} kv pärast"
        },
        "past": {
          "one": "{0} kv eest",
          "other": "{0} kv eest"
        }
      },
      "second": {
        "0": "nüüd",
        "future": {
          "one": "{0} sekundi pärast",
          "other": "{0} sekundi pärast"
        },
        "past": {
          "one": "{0} sekundi eest",
          "other": "{0} sekundi eest"
        }
      },
      "second-narrow": {
        "0": "nüüd",
        "future": {
          "one": "{0} s pärast",
          "other": "{0} s pärast"
        },
        "past": {
          "one": "{0} s eest",
          "other": "{0} s eest"
        }
      },
      "second-short": {
        "0": "nüüd",
        "future": {
          "one": "{0} sek pärast",
          "other": "{0} sek pärast"
        },
        "past": {
          "one": "{0} sek eest",
          "other": "{0} sek eest"
        }
      },
      "week": {
        "-1": "eelmine nädal",
        "0": "käesolev nädal",
        "1": "järgmine nädal",
        "future": {
          "one": "{0} nädala pärast",
          "other": "{0} nädala pärast"
        },
        "past": {
          "one": "{0} nädala eest",
          "other": "{0} nädala eest"
        }
      },
      "week-narrow": {
        "-1": "eelm. n",
        "0": "see n",
        "1": "järgm. n",
        "future": {
          "one": "{0} näd pärast",
          "other": "{0} näd pärast"
        },
        "past": {
          "one": "{0} näd eest",
          "other": "{0} näd eest"
        }
      },
      "week-short": {
        "-1": "eelm. näd",
        "0": "see näd",
        "1": "järgm. näd",
        "future": {
          "one": "{0} näd pärast",
          "other": "{0} näd pärast"
        },
        "past": {
          "one": "{0} näd eest",
          "other": "{0} näd eest"
        }
      },
      "year": {
        "-1": "eelmine aasta",
        "0": "käesolev aasta",
        "1": "järgmine aasta",
        "future": {
          "one": "{0} aasta pärast",
          "other": "{0} aasta pärast"
        },
        "past": {
          "one": "{0} aasta eest",
          "other": "{0} aasta eest"
        }
      },
      "year-narrow": {
        "-1": "eelm. a",
        "0": "see a",
        "1": "järgm. a",
        "future": {
          "one": "{0} a pärast",
          "other": "{0} a pärast"
        },
        "past": {
          "one": "{0} a eest",
          "other": "{0} a eest"
        }
      },
      "year-short": {
        "-1": "eelmine a",
        "0": "käesolev a",
        "1": "järgmine a",
        "future": {
          "one": "{0} a pärast",
          "other": "{0} a pärast"
        },
        "past": {
          "one": "{0} a eest",
          "other": "{0} a eest"
        }
      }
    },
    "locale": "et"
  });
}